import Icon from '@ant-design/icons/lib/components/Icon';
import * as React from 'react';
const ITasks = (props: any) => {
  return (
    <Icon
      component={() => {
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="23"
            height="23"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              d="M0 0H24V18.8125H17.761V23.5L10.9371 18.8125H0V0Z"
              fill={props.color}
            />
          </svg>
        );
      }}
      style={{paddingTop:"30px"}}
      {...props}
    />
  );
};

export default ITasks;
